import React from "react";
import useAppContext, { ACCOUNT_TYPES } from "state/AppContext";
import AdminClientsPage from "pages/AdminView/AdminClientsPage/AdminClientsPage";
import RecruiterClientsPage from "pages/RecruitersView/RecruiterClientsPage/RecruiterClientsPage";
import ErrorPage from "pages/ErrorPage/ErrorPage";

export default function ClientsSwitch() {
  const appContext = useAppContext();
  const { account } = appContext;
  const { accountType } = account;

  if (accountType.type === ACCOUNT_TYPES.ADMIN.type) {
    return <AdminClientsPage />;
  } else if (accountType.type === ACCOUNT_TYPES.RECRUITER.type) {
    return <RecruiterClientsPage />;
  } else {
    return <ErrorPage />;
  }
}
